import { createFileRoute } from '@tanstack/react-router';
import { BroadcastsPage } from '@web/modules/campaigns/broadcasts/broadcasts-page';

export const Route = createFileRoute('/_app/campaigns/broadcasts/')({
  component: BroadcastsPage,
});
